import Vue from 'vue'
import CustomToast from '@/components/CustomToast.vue'

const ToastConstructor = Vue.extend(CustomToast)

let toastInstance = null
const createToast = () => {
  if (!toastInstance) {
    toastInstance = new ToastConstructor()
    toastInstance.$mount()
    document.body.appendChild(toastInstance.$el)
  }
  return toastInstance
}

const showToast = (options) => {
  const instance = createToast()
  instance.show(options)
  return instance
}

const toast = {
  success (message, options = {}) {
    return showToast({
      type: 'success',
      message,
      title: options.title || '成功',
      ...options
    })
  },
  error (message, options = {}) {
    return showToast({
      type: 'error',
      message,
      title: options.title || '错误',
      duration: options.duration || 4000,
      ...options
    })
  },
  warning (message, options = {}) {
    return showToast({
      type: 'warning',
      message,
      title: options.title || '提示',
      ...options
    })
  },
  info (message, options = {}) {
    return showToast({
      type: 'info',
      message,
      title: options.title || '提示',
      ...options
    })
  },
  show (options) {
    return showToast(options)
  },
  close () {
    if (toastInstance) {
      toastInstance.close()
    }
  }
}

export default {
  install (Vue) {
    Vue.prototype.$toast = toast
  }
}

export { toast }
